import { ReplacementVehicleOptions } from '../interfaces/interface.lookup';

export const getReplacementVehicleMakeModels = (makesModels, replacementVehicleOptions: ReplacementVehicleOptions) => {
  if (!replacementVehicleOptions) {
    return makesModels;
  }
  const { replacementVehicleMakes, replacementVehicleModels } = replacementVehicleOptions;

  const rvMakes = [];
  const rvModels = [];
  if (replacementVehicleMakes && replacementVehicleModels && replacementVehicleMakes.length && replacementVehicleModels.length) {
    replacementVehicleMakes.forEach((make) => {
      rvMakes.push(`mm/${make}`);

      replacementVehicleModels.forEach((model) => {
        rvModels.push(`mm/${make}/${model}`);
      });
    });
  }

  if (rvMakes.length && rvModels.length) {
    return makesModels.filter((mm) => rvMakes.includes(mm.id)).map((make) => ({ ...make, values: make.values.filter((model) => rvModels.includes(model.id)) }));
  }

  return makesModels;
};
